import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=f7e6589a&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=f7e6589a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e6589a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7e6589a')) {
      api.createRecord('f7e6589a', component.options)
    } else {
      api.reload('f7e6589a', component.options)
    }
    module.hot.accept("./ModalHeader.vue?vue&type=template&id=f7e6589a&scoped=true", function () {
      api.rerender('f7e6589a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/modal/ModalHeader.vue"
export default component.exports